import { endpoints } from "../config/api";
import { fetchAllOrgUsers } from "./fetchOrgUsers";

export const decodeAccessTokenPayload = () => {
  try {
    const token = localStorage.getItem("access_token");
    if (!token) return null;
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
};

const toNumericId = (value) => {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isNaN(n) ? null : n;
};

/** Email from the logged-in user's access token, if present. */
export const getEmailFromToken = () => {
  const payload = decodeAccessTokenPayload();
  const email = payload?.email ?? payload?.email_address;
  return typeof email === "string" && email.trim() ? email.trim() : null;
};

/** Numeric user_index from JWT claims only (user_index / userIndex / user_id / userId). */
export const getUserIndexFromToken = () => {
  const payload = decodeAccessTokenPayload();
  if (!payload) return null;

  for (const key of ["user_index", "userIndex", "user_id", "userId"]) {
    const value = toNumericId(payload[key]);
    if (value != null) return value;
  }

  return null;
};

/**
 * Resolve user_index for the logged-in user.
 * JWT usually has email/orgId but not user_index — falls back to org users lookup by email.
 */
export const resolveCurrentUserIndex = async () => {
  const fromToken = getUserIndexFromToken();
  if (fromToken != null) return fromToken;

  const payload = decodeAccessTokenPayload();
  const email = getEmailFromToken();
  if (!email) return null;

  const orgGroups = await fetchAllOrgUsers(endpoints.orgsUsers, { limit: 100 });
  const emailLower = email.toLowerCase();
  const tokenOrgId = payload?.orgId ?? payload?.org_id;
  const matches = [];

  for (const org of orgGroups) {
    for (const user of org.users || []) {
      if (user.email?.toLowerCase() !== emailLower) continue;
      const userIndex = toNumericId(user.user_index ?? user.user_id);
      if (userIndex == null) continue;
      matches.push({ userIndex, orgId: org.organization_id });
    }
  }

  if (matches.length === 0) return null;

  if (tokenOrgId != null) {
    const orgMatch = matches.find((match) => String(match.orgId) === String(tokenOrgId));
    if (orgMatch) return orgMatch.userIndex;
  }

  return matches[0].userIndex;
};
